<!-- 注册sp1 -->
<template>
    <div class="sp1">
        <div class="sp1-main">
            <div class="sp1-title">———————————— 注册企业账户 ————————————</div>
            <el-form :model="sp1Form" :rules="rules" ref="sp1Form" label-width="100px">
                <el-form-item label="企业名称" prop="StoreName">
                    <el-input
                            v-model.trim="sp1Form.StoreName"
                            v-filter-special-char="sp1Form.StoreName"
                    ></el-input>
                </el-form-item>
                <el-form-item label="商家类型" prop="shopTypeLocal">
                    <el-select v-model="sp1Form.shopTypeLocal" placeholder="请选择商家类型   ">
                        <el-option v-for="item in shopTypeLocalList" :label="item.TValue" :value="item.TKey " :key="item.TKey"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="地址" prop="City">
                    <Region @getRegion="getRegion"></Region>
                </el-form-item>
                <el-form-item label="详细地址" prop="Address">
                    <el-input type="textarea"
                              v-model.trim="sp1Form.Address"
                    ></el-input>
                </el-form-item>
                <el-form-item label="企业负责人" prop="Contactor">
                    <el-input
                            v-model.trim="sp1Form.Contactor"
                            v-filter-special-char="sp1Form.Contactor"
                    ></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="PhoneNum">
                    <el-input v-model.trim="sp1Form.PhoneNum"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="code">
                    <el-input v-model.trim="sp1Form.code"
                              style="width: 70%;margin-right: 20px"
                    ></el-input>
                    <el-button v-if="getCodeSuccess">{{countdown}}后重新获取</el-button>
                    <el-button v-else @click="getCode">获取验证码</el-button>
                </el-form-item>
                <el-form-item label="" prop="agree">
                    <el-checkbox-group v-model="sp1Form.agree" style="display: inline-block">
                        <el-checkbox name="type"></el-checkbox>
                    </el-checkbox-group>
                    <span class="read-agree" @click="dialogVisible=true">我已阅读并同意
                        <span style="color: #409eff">《车回佳-商家入驻合作协议》</span>
                    </span>
                </el-form-item>
                <el-form-item>
                    <el-button class="btn-primary" @click="submitForm()">下一步</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-dialog
                :close-on-click-modal="false"
                title="车回佳-商家入驻合作协议"
                :visible.sync="dialogVisible"
                width="850px"
        >
            <agree></agree>
        </el-dialog>
    </div>
</template>
<script>
    import Region from '@/components/common/address.vue'
    import agree from './agree'
    import mixin from  '@/mixins/mixin'
    export default {
        mixins: [mixin],
        name: '',
        components: {
            agree,
            Region
        },
        data(){
            // 手机号校验
            let checkPhone = this.$util.validateMobile;
            // let checkPhone = (rule, value, callback) => {
            //     const reg =  /^1[3-9]\d{9}$/
            //     if (reg.test(value)) {
            //         callback();
            //     } else {
            //         return callback(new Error('请输入正确的手机号'));
            //     }

            // };
            return {
                shopTypeLocalList:[],
                dialogVisible:false,
                countdown:120,
                getCodeSuccess:false,
                sp1Form: {
                    agree:true,
                    code:'',
                    addressLocal:[],// 地址三级联动
                    shopTypeLocal:'',
                    StoreName: '',
                    ProjectType:'',
                    Province:'',
                    City:'',
                    Zone:'',
                    Address:'',
                    Contactor:'',
                    PhoneNum:'',
                },
                rules: {
                    StoreName: [
                        { required: true, message: '请输入企业名称', trigger: 'blur' },
                    ],
                    shopTypeLocal: [
                        { required: true, message: '请选择商家类型', trigger: 'change' }
                    ],
                    City: [
                        { required: true, message: '请填选择地址', trigger: 'blur' }
                    ],
                    // Address: [
                    //     { required: true, message: '请填写详细地址', trigger: 'blur' }
                    // ],
                    Contactor: [
                        { required: true, message: '请填写联系人', trigger: 'blur' }
                    ],
                    PhoneNum: [
                        { required: true,validator: checkPhone,trigger: 'blur' }
                    ],
                    code: [
                        {required: true, message: '请填写验证码', trigger: 'blur' }
                    ],
                    agree: [
                        { required: true, message: '请阅读并同意我们的用户协议', trigger: 'blur' }
                    ]
                }
            }
        },
        mounted(){
            let sp1Data = this.$util.getLocalStorage('sp1Form');
            if (sp1Data){
                this.sp1Form = sp1Data
            }
            this.getShopType()
        },
        watch:{
            'sp1Form.addressLocal'(value){
                this.sp1Form.Province = value[0]
                this.sp1Form.City = value[1]
                this.sp1Form.Zone = value[2]



            },
            'sp1Form.shopTypeLocal'(value){
                let val = Number(value)
                let _shopTypeLocalList = this.shopTypeLocalList
                for (let i=0;i<_shopTypeLocalList.length;i++){
                    if(_shopTypeLocalList[i].TKey == val){
                        this.sp1Form.ProjectType = _shopTypeLocalList[i].TValue
                        break
                    }
                }
            }
        },
        methods:{
            getRegion(value){
               this.sp1Form.addressLocal =  value
            },
            getShopType(){
                this.$util.getConfigData('BusinessType-A').then((res)=>{
                    this.shopTypeLocalList = res
                })
            },
            // 获取验证码
            getCode (){
                const reg =  /^1[3-9]\d{9}$/
                if (!reg.test(this.sp1Form.PhoneNum) || !this.sp1Form.PhoneNum){
                    this.$util.warningMsg('请输入正确的手机号')
                    return
                }
                this.getCodeSuccess = true
                let time = 60
                let timer = setInterval(()=> {
                    if (time == 0){
                        clearInterval(timer)
                        this.getCodeSuccess = false
                        return
                    }
                    time = time -1
                    this.countdown = time
                },1000)
                let country=this.$util.validateMobileCountry(this.sp1Form.PhoneNum);
                if(!country){
                    this.$util.warningMsg('手机号码格式不正确，无法获取验证码')
                    return;
                }
                this.$util.axiosPost({
                    url:`/api/PhoneVerCode/SentPhoneVerCode?phoneNum=${this.sp1Form.PhoneNum}&country=${country}`,
                }).then(()=>{

                }).catch(()=>{})
            },
            // 检验验证码
            checkCode (){
               return new Promise((resolve)=>{
                   this.$util.axiosPost({
                       url:'/api/PhoneVerCode/CheckPhoneVerCode',
                       data:{
                           phoneNum:this.sp1Form.PhoneNum,
                           verCode:this.sp1Form.code
                       },
                   }).then((res)=>{
                       if (res){
                           resolve()
                       }
                       else {
                           this.$util.warningMsg('验证码错误')
                       }
                   }).catch(()=>{})
                })
            },
            // 提交数据
            submitForm() {
                let that = this
                if (!this.sp1Form.agree){
                    that.$util.warningMsg('请阅读并同意我们的协议')
                    return
                }
                this.$refs.sp1Form.validate((valid) => {
                    if (valid) {
                        that.checkCode().then(()=>{
                            that.$store.commit('updateSp1Form',that.sp1Form)
                            that.$util.setLocalStorage('sp1Form',that.sp1Form)
                            that.$router.push(`/registered/step2?shopType=${that.sp1Form.shopTypeLocal}`)
                        });
                    }
                    else {
                        return false;
                    }

                })

            },
        }
    }
</script>
<style lang="less" scoped>
    .sp1 {
        padding-bottom: 50px;
    }
    .sp1-title {
        text-align: center;
        font-size: @font-lg;
        margin-bottom: 35px;
    }
    .sp1-main {
        padding-top: 100px;
        max-width: 700px;
        margin: 0 auto;
    }
    .read-agree {
        display: inline-block;
        margin-left:20px ;
        cursor: pointer;
    }
</style>
<style lang="less">
    .area-select .area-selected-trigger {
        padding: 0 20px;
        line-height: 30px;
    }
    .area-select-wrap .area-select {
        margin-left: 0px !important;
        margin-right: 10px;
    }
    .company-name {

    }
</style>
